import { CAROUSEL_TYPES, TEXT_POSITION_TYPES } from 'src/models/carousel/Carousel'
import { BUTTON_TYPES, DISPLAY_DATE_TYPES } from 'src/models/page/Section'

export const createNewsCarousel = () => {
  return {
    autoplay: true,
    backgroundColor: 'custom',
    backgroundColorHex: '#000000',
    borderRadius: 0,
    buttonBorderRadius: 0,
    buttonColor: 'custom',
    buttonColorHex: '#ffffff',
    buttonType: BUTTON_TYPES.OUTLINE,
    controlsVisible: false,
    dateType: DISPLAY_DATE_TYPES.PUBLISHED,
    delayInSeconds: 6,
    hasPartialSlide: false,
    isTextCentred: true,
    isTextLight: true,
    newsItemClassIds: [],
    newsItemKeepImageRatio: false,
    paginationVisible: false,
    showHeading: true,
    showItemButton: true,
    showItemClass: false,
    showItemDate: false,
    showItemDescription: true,
    showItemSubtitle: false,
    showItemTitle: true,
    sliderAllowLoop: true,
    sliderGutter: 5,
    sliderPaginateGroupedSlides: false,
    sliderShadow: 0,
    slidesPerView: 3,
    textPosition: TEXT_POSITION_TYPES.BOTTOM,
    type: CAROUSEL_TYPES.CAROUSEL
  }
}
